import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
    if (this.getUser()) {
      this.isLoginUser.next(true);
    } else {
      this.isLoginUser.next(false);
    }
  }

  getItem(name: string) {
    const data = localStorage.getItem(name);
    return (data) ? (data) : null;
  }

  setItem(name: string, item: string) {
    localStorage.setItem(name, (item));
  }

  removeItem(name: string) {
    localStorage.removeItem(name);
  }

  //--------------------Local Storage Start--------------
  getStorageItem(name: string) {
    const localStorage = this.document.defaultView?.localStorage;
    const data = localStorage ? localStorage.getItem(name) : null;
    if (data) { try { return decodeURIComponent(escape(atob(data))); } catch (e) { return null; } }
    else { return null; }
  }

  setStorageItem(name: string, item: any) {
    const localStorage = this.document.defaultView?.localStorage;
    if (localStorage)
      localStorage.setItem(name, btoa(unescape(encodeURIComponent(item))));
  }

  removeStorageItem(name: string) {
    const localStorage = this.document.defaultView?.localStorage;
    if (localStorage)
      localStorage.removeItem(name);
  }

  //--------------------Local Storage End-------------- 

  // ------Login-logout related things-------
  public isLoginUser: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private localStorageKey = "lmf_user";
  setUser(user: any) {
    this.setStorageItem(this.localStorageKey, JSON.stringify(user, null, 2));
    this.isLoginUser.next(true);
  }

  getUser() {
    const loginUser = this.getStorageItem(this.localStorageKey);
    return (loginUser) ? JSON.parse(loginUser) : null;
  }
  logoutUser() {
    this.removeStorageItem(this.localStorageKey);
    this.isLoginUser.next(false);
  }
  // -------------------- End --------------------------
 // loader
  show() {
    this.isLoading$.next(true);
  }
  hide() {
    this.isLoading$.next(false);
  }
}
